import { render } from "./Reviews.vue?vue&type=template&id=38f711fc&scoped=true"
import script from "./Reviews.vue?vue&type=script&lang=js"
export * from "./Reviews.vue?vue&type=script&lang=js"

import "./Reviews.vue?vue&type=style&index=0&id=38f711fc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f711fc"]])

export default __exports__